import React from 'react';

import { CmsPreviewView } from '@ndvr/cms-api';

import { CmsSnapshotPreview } from './cms-rendering';

export const CmsArtifactDiff = ({
    reviewPreview,
    publishedPreview,
}: {
    reviewPreview: CmsPreviewView;
    publishedPreview?: CmsPreviewView;
}) => (
    <div className="grid gap-4 xl:grid-cols-2">
        <div>
            <h3 className="mb-2 text-base font-semibold">Review artifact</h3>
            <CmsSnapshotPreview preview={reviewPreview} />
        </div>
        <div>
            <h3 className="mb-2 text-base font-semibold">Current published artifact</h3>
            {publishedPreview ? (
                <CmsSnapshotPreview preview={publishedPreview} />
            ) : (
                <div className="text-muted-foreground flex min-h-[280px] items-center justify-center rounded-md border border-dashed bg-white p-8 text-center text-sm">
                    First publish: there is no prior published artifact.
                </div>
            )}
        </div>
    </div>
);
